export const Feature = {
  ENHANCE_INCIDENT_DESCRIPTION: 'ENHANCE_INCIDENT_DESCRIPTION',
  ENHANCE_INCIDENT_COMMENTS: 'ENHANCE_INCIDENT_COMMENTS',
};

export const EnhanceStatus = {
  IDLE: 'idle',
  LOADING: 'loading',
  REVIEW: 'review',
  ERROR: 'error',
};

export const LoadStatus = {
  IDLE: 'idle',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error',
};
